import { ClassProvider } from '@angular/core'
import { HTTP_INTERCEPTORS } from '@angular/common/http'

import { RangeLimitInterceptor } from '../interceptors/range-limit.interceptor'

export const RANGE_LIMIT_INTERCEPTOR: ClassProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: RangeLimitInterceptor,
  multi: true,
}
